<div class="loan-amount-grid-wrapper" data-testid="loan-amount-grid-wrapper">

  <div class="loan-amount-grid-hint" *ngIf="requiresMandateSelection && !hasSelectedMandate" data-testid="loan-amount-grid-mandate-hint">
    Select a mandate before editing loan numbers.
  </div>

  <!-- Inactive loans toggle -->
  <div class="loan-amount-grid-toolbar" *ngIf="config?.showCheckbox !== false">
    <dx-check-box class="loan-amount-grid-check-box" data-testid="loan-amount-grid-show-inactive" text="Show Inactive Loans" [value]="showInactiveLoans"
      [disabled]="!canEditGrid || isGridInEditMode || (value && value.length > 0)" (onValueChanged)="onShowInactiveChanged($event)">
    </dx-check-box>
  </div>

  <dx-data-grid data-testid="loan-amount-grid" [dataSource]="value" keyExpr="key" [columns]="columns"
    [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
    (onInitialized)="onGridInitialized($event)" (onRowInserted)="onRowInserted($event)"
    (onRowUpdated)="onRowUpdated($event)" (onRowRemoved)="onRowRemoved($event)" (onEditingStart)="onEditingStart()"
    (onInitNewRow)="onInitNewRow($event)" (onSaved)="onSaved()"
    (onEditCanceled)="onEditCanceled()" (onCellPrepared)="onCellPrepared($event)"
    (onRowPrepared)="onRowPrepared($event)" (onEditorPreparing)="onEditorPreparing($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)">

    <dxo-editing mode="row" [allowAdding]="canAddRows && hasAvailableItems" [allowUpdating]="canEditGrid" [allowDeleting]="canEditGrid"
      [confirmDelete]="false" />
    <dxo-paging [enabled]="false" />
    <dxo-load-panel [enabled]="false" />
  </dx-data-grid>

</div>